import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";

interface OperatorMemberDepositState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorMemberDepositState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorMemberDepositSelects = {
  loading: (state: RootState) => state.operatorMemberDeposit.loading,
  dateRange: (state: RootState) => state.operatorMemberDeposit.dateRange,
  queryParams: (state: RootState) => state.operatorMemberDeposit.queryParams,
  transfers: (state: RootState) => state.operatorMemberDeposit.transfers,
};

export const operatorMemberDepositThunks = {
  list: createAsyncThunk(
    "operatorMemberDeposit/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.MemberDeposit,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorMemberDepositSlice = createSlice({
  name: "operatorMemberDeposit",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorMemberDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorMemberDepositThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorMemberDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorMemberDepositActions = operatorMemberDepositSlice.actions;
